import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import DeviceLayout from "./layout";
import AuthLayout from "./layout/auth-layout";
import PageLayout from "./layout/page-layout";
import "./App.css";
import Markets from "./pages/markets";
import RevenueReport from "./pages/reports/RevenueReport";
import CashOutStandingReport from "./pages/reports/CashOutStandingReport";
import TradeOverviewReport from "./pages/reports/TradeOverviewReport";
import Payments from "./pages/payments/ui/payments";
import RiskEngine from "./pages/risk-engine";
import Composition from "./pages/risk-engine/composition";

const Myprofile = lazy(() => import("./pages/my-profile"));

const LoansV2 = lazy(() => import("./pages/loansV2"));

const ApplicationView = lazy(
  () => import("./pages/loans/Applications/application-view"),
);

const PricePrediction = lazy(
  () => import("./pages/daily-price/price-prediction"),
);

const SupplyPostView = lazy(() => import("./pages/supply/supply-post-details"));
const DemandPostView = lazy(() => import("./pages/demand/demand-post-details"));
const PostDetails = lazy(() => import("./pages/supply/post-details"));

const Reports = lazy(() => import("./pages/reports"));
const DebitCreditReports = lazy(
  () => import("./pages/reports/debitCreditReports"),
);
const OpenTradesPaymentReports = lazy(
  () => import("./pages/reports/OpenTradesPaymentReports"),
);
const AllTradeDetailReports = lazy(
  () => import("./pages/reports/AllTradeDetailReports"),
);
const ExcessPaymentReport = lazy(
  () => import("./pages/reports/ExcessPaymentReport"),
);
const EmployeeAttendance = lazy(
  () => import("./pages/reports/EmployeeAttendance"),
);

const GstReport = lazy(() => import("./pages/reports/gstReport"));
const MosSubscriptionReport = lazy(
  () => import("./pages/reports/MosSubscriptionReport"),
);

const CaClickUsageReport = lazy(
  () => import("./pages/reports/CaClickUsageReport"),
);

const OnoOutstandingBalance = lazy(
  () => import("./pages/reports/OnoOutStandBal"),
);

const WalletReport = lazy(() => import("./pages/reports/walletReport"));

const CashReport = lazy(() => import("./pages/reports/CashReport"));

const LoanTradeDetailsReport = lazy(
  () => import("./pages/reports/LoanTradeDetailsReport"),
);

const DailyBusinessReport = lazy(
  () => import("./pages/reports/DailyBusinessSummaryReport"),
);

const TradeOutstandingReport = lazy(
  () => import("./pages/reports/TradeOutstandingReport"),
);

const CashRecoveryReport = lazy(
  () => import("./pages/reports/CashRecoveryReport"),
);

const TradeTimeLines = lazy(() => import("./pages/reports/TradeTimeLines"));

const ActiveCustomersReport = lazy(
  () => import("./pages/reports/ActiveCustomersReport"),
);

const EmploBusinSmry = lazy(
  () => import('./pages/reports/EmployeeBusiSummary'),
);

const CashOverviewReport = lazy(
  () => import("./pages/reports/CashOverviewReport"),
);

const WalletBalanceReport = lazy(
  () => import('./pages/reports/WalletBalances'),
);

const SubscriberOverviewReport = lazy(
  () => import('./pages/reports/SubscriberOverview'),
);

const CustomersV2 = lazy(() => import("./pages/customersV2"));
const CustomerDetails = lazy(
  () => import("./pages/customersV2/customerDetails"),
);
const Trades = lazy(() => import("./pages/trade-detail_v2/trades"));
const Partners = lazy(() => import("./pages/partners"));

function App() {
  return (
    <DeviceLayout>
      <AuthLayout>
        <PageLayout>
          <Suspense fallback={<>Loading...</>}>
            <Routes>
              <Route path="/" element={<CustomersV2 />} />
              <Route path="/customers" element={<CustomersV2 />} />
              <Route
                path="/customer-details/:mosId"
                element={<CustomerDetails />}
              />

              <Route path="/my-profile" element={<Myprofile />} />
              {/* <Route path="/customers" element={<Customer />} /> */}
              <Route path="/trades" element={<Trades />} />
              <Route path="/loans" element={<LoansV2 />} />
              {/* <Route path="/traders-view" element={<TraderDetailsView />} /> */}
              <Route path="/payments" element={<Payments />} />
              <Route
                path="/application-view/:applicationId"
                element={<ApplicationView />}
              />
              <Route
                path="/supply-details/:postId"
                element={<SupplyPostView />}
              />
              <Route
                path="/demand-details/:postId"
                element={<DemandPostView />}
              />
              <Route path="/post-details" element={<PostDetails />} />
              <Route path="/reports" element={<Reports />}>
                <Route
                  path="/reports/debit-credit-reports"
                  element={<DebitCreditReports />}
                />
                <Route
                  path="/reports/payment-receipts"
                  element={<OpenTradesPaymentReports />}
                />
                <Route
                  path="/reports/allTradeDetail-Reports"
                  element={<AllTradeDetailReports />}
                />
                <Route
                  path="/reports/ExcessPayment-Reports"
                  element={<ExcessPaymentReport />}
                />
                <Route
                  path="/reports/employee-attendance"
                  element={<EmployeeAttendance />}
                />
                <Route
                  path="/reports/gst-reconciliation"
                  element={<GstReport />}
                />
                <Route
                  path="/reports/mos-subscription"
                  element={<MosSubscriptionReport />}
                />
                <Route
                  path="/reports/ca-click-usage"
                  element={<CaClickUsageReport />}
                />
                <Route path="/reports/cash-report" element={<CashReport />} />
                <Route
                  path="/reports/wallet-report"
                  element={<WalletReport />}
                />
                <Route
                  path="/reports/revenue-report"
                  element={<RevenueReport />}
                />
                <Route
                  path="/reports/cash-outstanding-report"
                  element={<CashOutStandingReport />}
                />
                <Route
                  path="/reports/trade-overview-report"
                  element={<TradeOverviewReport />}
                />
                <Route
                  path="/reports/daily-business-report"
                  element={<DailyBusinessReport />}
                />
                <Route
                  path="/reports/trade-outstanding-report"
                  element={<TradeOutstandingReport />}
                />
                <Route
                  path="/reports/ono-outstanding-balance-report"
                  element={<OnoOutstandingBalance />}
                />
                <Route
                  path="/reports/cash-recovery-report"
                  element={<CashRecoveryReport />}
                />
                <Route
                  path="/reports/trade-cash-report"
                  element={<LoanTradeDetailsReport />}
                />
                <Route
                  path="/reports/active-customers-report"
                  element={<ActiveCustomersReport />}
                />
                <Route
                  path="/reports/trade-timelines"
                  element={<TradeTimeLines />}
                />
                <Route
                  path="/reports/cash-overview"
                  element={<CashOverviewReport />}
                />
                <Route
                  path="/reports/employee-business-summary"
                  element={<EmploBusinSmry />}
                />
                <Route
                  path="/reports/wallet-balance"
                  element={<WalletBalanceReport />}
                />
                <Route
                  path="/reports/subscriber-overview"
                  element={<SubscriberOverviewReport />}
                />
              </Route>
              <Route path="/markets" element={<Markets />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/risk-engine" element={<RiskEngine />} />
              <Route
                path="/risk-engine/composition"
                element={<Composition />}
              />
              <Route path="/price-prediction" element={<PricePrediction />} />
            </Routes>
          </Suspense>
        </PageLayout>
      </AuthLayout>
    </DeviceLayout>
  );
}

export default App;
